import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const playgroundPlugin = createPlugin({
  id: 'playground',
  routes: {
    root: rootRouteRef,
  },
});

export const PlaygroundPage = playgroundPlugin.provide(
  createRoutableExtension({
    name: 'PlaygroundPage',
    component: () =>
      import('./components/TodoListPage').then(m => m.TodoListPage),
    mountPoint: rootRouteRef,
  }),
);
